import React, { useEffect, useState } from "react";
import headerLogosMap from "./header.logos.map";
import { Icon } from "@/shared/ui/Icon";
import { Row } from "@/shared/ui/Blocks";
import { BurgerMenuButton } from "@/shared/ui/BurgerMenuButton";
import { useNavigationContainer } from "@/shared/contexts/navigation.context";
import { OrganizationSelectDropdown } from "@/features/organization/components/OrganizationSelectDropdown";
import useOrgRoute from "@/shared/utils/router/useOrgRoute";
import { useOrganisation } from "@/features/organization/hooks/useOrganisation";
import { BreadcrumbsPortal } from "../Breadcrumbs";
import { HeaderContentPortal } from "../HeaderContent";
import useOrgNavigate from "@/shared/utils/router/useOrgNavigate";
import { useAccount } from "@/features/workspace/hooks/useAccount";
import { cn } from "@/shared/utils/shadcn";

export const BaseHeader = ({
  children,
  className,
  onLogoClick,
}: {
  children: React.ReactNode;
  className?: string;
  onLogoClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}) => {
  const { account } = useAccount();
  const Logo = headerLogosMap.assessio;

  const customLogo = account?.config?.logo;

  return (
    <Row
      className={cn(
        "sticky top-0 z-50 h-[64px] w-screen items-center justify-between bg-grey-100 select-none",
        className
      )}
    >
      <div
        className={cn("pl-6 z-50", onLogoClick && "cursor-pointer")}
        onClick={onLogoClick}
      >
        {customLogo ? (
          <img src={customLogo} alt="Account Logo" className="h-8" />
        ) : (
          <Logo className="h-4 w-auto" />
        )}
      </div>
      {children}
    </Row>
  );
};

function Header() {
  const { organization: selectedOrg } = useOrganisation();
  const { mobileOpen, toggleMobileSidebar, shouldUseMobileUI } =
    useNavigationContainer();
  const navigate = useOrgNavigate();
  const { isOrgRoute } = useOrgRoute();

  return (
    <BaseHeader onLogoClick={() => navigate("/dashboard")}>
      {selectedOrg.id && isOrgRoute && (
        <Row className="ml-4 gap-4">
          <OrganizationSelectDropdown side="bottom" align="start">
            <Row className="items-center gap-1 p-1 hover:bg-grey-300 rounded-md cursor-pointer">
              <div className="w-2 h-2 mr-1 rounded-xs bg-green-500" />
              <p className="text-sm font-semibold max-w-[150px] overflow-hidden text-ellipsis whitespace-nowrap">
                {selectedOrg.name}
              </p>
              <Icon size="xs" icon="Expand" />
            </Row>
          </OrganizationSelectDropdown>
        </Row>
      )}
      <BreadcrumbsPortal />

      <Row className="flex-1 h-full px-6 z-40 items-center gap-4 justify-end">
        <HeaderContentPortal />
        {shouldUseMobileUI && (
          <BurgerMenuButton
            isOpen={mobileOpen}
            onClick={() => toggleMobileSidebar()}
          />
        )}
      </Row>
    </BaseHeader>
  );
}

export { Header };
